const ITEMS = [
  "Clear Pricing",
  "Flexible Appointments",
  "Houses & Apartments",
  "Dublin & Kildare",
  "Photos For A Fast Quote",
  "Optional Rubbish Removal",
];

export const Marquee = () => {
  const line = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-emerald-100 bg-emerald-50 py-5" data-testid="trust-marquee">
      <div className="marquee-track">
        {line.map((item, i) => (
          <div key={i} className="flex items-center whitespace-nowrap px-8">
            <span className="font-display text-lg font-bold uppercase tracking-wide text-emerald-800">
              {item}
            </span>
            <span className="ml-16 h-1.5 w-1.5 rounded-full bg-emerald-400" />
          </div>
        ))}
      </div>
    </div>
  );
};
